import React, { useContext, useEffect, useState } from "react";
import PlanUsuario from "./PlanUsuario"
import Boton from "./Boton"
import { AppContext } from "./index";
import { clBasic } from "./general";

export default function PlanIncidentes() {
    let { firebase } = useContext(AppContext);

    let colorCelda = ["#F5D0A9", "#F3F781", "#D0F5A9"]
    const [plan, setPlan] = useState(null)
    const [refresh, setRefresh] = useState(false)
    const [change, setChange] = useState(false)

    useEffect(() => { setPlan(firebase.incidentesPlan()) }, [firebase])

    useEffect(() => {
        document.getElementById("htmlTituloPagS").innerHTML = "Planficación de Incideentes";
    }, []);

    function allowDrop(e) {
        e.preventDefault();
    }

    function drop(e) {
        e.preventDefault();
        let data = JSON.parse(e.dataTransfer.getData("text"));
        if (data.obj === "incidente") {
            // es un incidente, lo quito de la lista del usuario original y lo agrego a la lista de este usuario
            let usrDestino = e.currentTarget.id
            let usrOriginal = data.i.responsable
            let usrActual = data.i.usuarioActual
            let planOld = { ...plan }
            if (usrDestino === usrActual) return;

            if (data.i.responsable === data.i.usuarioActual) { //moviendo el incidente con asignacion original
                planOld[usrDestino][data.i.grupo].push({ ...data.i, usuarioActual: usrDestino })
                planOld[usrOriginal][data.i.grupo][data.ind].usuarioActual = usrDestino
            }
            else {
                // es un incidente que se habia movido 
                if (usrDestino === usrOriginal) {  // se esta volviendo al usuario original
                    // busco posicion en que ya estaba el usuario originalmente
                    let posOriginal
                    planOld[usrDestino][data.i.grupo].forEach((inc, pos) => {
                        if (inc.id === data.i.id)
                            posOriginal = pos;
                    });
                    // en el destino (que es el origen...) elimino referencia al cambio 
                    planOld[usrDestino][data.i.grupo][posOriginal].usuarioActual = usrOriginal
                    console.log('muevo uno movido a la usr original, posoriginal', posOriginal)
                    console.log(planOld[usrDestino][data.i.grupo])

                }
                else {
                    console.log('muevo uno movido a un usuario que no es el original')
                    planOld[usrDestino][data.i.grupo].push({ ...data.i, usuarioActual: usrDestino })
                    console.log(planOld[usrDestino][data.i.grupo])
                }

                // en el que origina el cambio lo elimino puesto que se habia movido pero no era original
                planOld[usrActual][data.i.grupo].splice(data.ind, 1)
            }

            // actualizo estado y renderizo la nueva distribucion de incidentes
            setPlan(planOld)
            setRefresh(!refresh)
            setChange(true)
            return;
        }
    }

    function actualizarPlan() {
        firebase.actualizarPlan(plan)
        setChange(false)
    }

    return (
        <div id="PIplanIncidentes" style={Splan}>
            <div style={StituloLinea}>
                <div style={{ ...Stitulo, background: colorCelda[0] }}>7 días</div>
                <div style={{ ...Stitulo, background: colorCelda[1] }}>15 días</div>
                <div style={{ ...Stitulo, background: colorCelda[2] }}>Mediano plazo</div>
            </div>

            <div style={Splanificacion}>
                {plan && Object.keys(plan).map(usr =>
                    <div style={Susuario} key={usr} id={usr} onDrop={(e) => drop(e)} onDragOver={(e) => allowDrop(e)}>
                        <div style={Sfoto}>
                            <img src={firebase.usuario(usr).url} alt="?" height="35px" width="35px" style={{
                                margin: "auto",
                                clipPath: "circle(50%)"
                            }} />
                            <div>{firebase.usuario(usr).nombre}</div>
                        </div>
                        <div style={SplanUsuario}>
                            <PlanUsuario listaIncidentes={plan[usr]} usuario={usr} />
                        </div>
                    </div>
                )}
            </div>

            <Boton accion={actualizarPlan} change={change} />
        </div>
    )
}

const Splan = {
    width: "90vw",
    height: "90vh",
    marginRight: "10px",
}

const StituloLinea = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    marginLeft: "9.3vw",
}
const Stitulo = {
    fontSize: "2.7vh",
    fontWeight: 700,
    marginBottom: "15px",
    padding: "10px 0px 10px 0px",
    textAlign: "center",
    width: "23.4vw",
    marginLeft: "32px",
    color: clBasic
}
const Splanificacion = {
    width: "100%",
    height: "70vh",
    overflowY: "auto"
}

const Susuario = {
    width: "100%",
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
    color: clBasic,
    marginBottom: "7px",
    background: "#e6e6e6",
    borderRadius: "10px",
    padding: "5px"
}

const SplanUsuario = {
    width: "90%",
    maxHeight: "16vh",
    minHeight: "8vh",
    margin: "10px"
}

const Sfoto = {
    width: "10%",
    textAlign: "center",
    fontSize: "1.6vh",
    itemAlign: "center",
    margin: "auto"
}